import { useState } from "react";
import { AmbientGlow, CheckMark, TapeLabel } from "./_shared";

// Ported from Claude Design handoff (Direction A: SinalFeatures).
// Numbered metadata cards with mono "01 · SHIELD" top, hover brightens elev.

const PILLARS = [
  {
    icon: "Shield",
    title: "Monitoramento 24/7 com IA",
    body:
      "Uptime, certificados SSL, blacklists e domínios monitorados em tempo real. A IA detecta anomalias antes que virem problemas.",
    bullets: [
      "11+ tipos de monitoramento contínuo",
      "Alertas automáticos por severidade",
      "Score de segurança de 0 a 100",
    ],
  },
  {
    icon: "FileText",
    title: "Relatórios que Qualquer Um Entende",
    body:
      "Relatórios mensais em PDF com linguagem simples. Sem jargão técnico. Seu time entende na primeira leitura.",
    bullets: [
      "Gerados pela IA em português",
      "PDF profissional para stakeholders",
      "Recomendações priorizadas de ação",
    ],
  },
  {
    icon: "ShieldCheck",
    title: "Conformidade LGPD Automatizada",
    body:
      "Dashboard interativo mapeando seus monitoramentos aos artigos da LGPD. Conformidade comprovada sem esforço manual.",
    bullets: [
      "Mapeamento artigo por artigo",
      "Evidence de compliance automática",
      "Argumento de venda para clientes enterprise",
    ],
  },
];

export function Features3Pillars() {
  const [active, setActive] = useState(0);

  return (
    <section
      id="solucao"
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tl-br" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1360,
          margin: "0 auto",
        }}
      >
        <div style={{ maxWidth: 760, marginBottom: 64 }}>
          <TapeLabel>A SOLUÇÃO</TapeLabel>
          <h2
            style={{
              fontFamily: "var(--cy-fs-sans)",
              fontSize: "clamp(36px, 4.5vw, 52px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
              fontWeight: 500,
              margin: "20px 0 0",
              color: "var(--cy-ink-100)",
              textWrap: "balance",
            }}
          >
            Tudo que sua empresa precisa para estar segura
          </h2>
        </div>

        <div
          className="cy-grid-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 20,
          }}
        >
          {PILLARS.map((p, i) => (
            <div
              key={i}
              onMouseEnter={() => setActive(i)}
              style={{
                padding: "32px 28px",
                border: "1px solid",
                borderColor:
                  active === i
                    ? "rgba(132,255,0,0.28)"
                    : "var(--cy-ink-10)",
                background:
                  active === i ? "var(--cy-bg-elev)" : "var(--cy-bg)",
                transition: "background .25s ease, border-color .25s ease",
                minHeight: 420,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {active === i && (
                <div
                  aria-hidden
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 1,
                    background:
                      "linear-gradient(90deg, transparent, var(--cy-accent), transparent)",
                  }}
                />
              )}
              <div
                className="cy-mono"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.14em",
                  color:
                    active === i
                      ? "var(--cy-accent)"
                      : "var(--cy-ink-60)",
                  textTransform: "uppercase",
                  marginBottom: 80,
                }}
              >
                0{i + 1} · {p.icon}
              </div>

              <div
                style={{
                  fontFamily: "var(--cy-fs-sans)",
                  fontSize: 26,
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  fontWeight: 500,
                  color: "var(--cy-ink-100)",
                  marginBottom: 16,
                }}
              >
                {p.title}
              </div>
              <div
                style={{
                  fontSize: 14,
                  lineHeight: 1.55,
                  color: "var(--cy-ink-60)",
                  marginBottom: 24,
                }}
              >
                {p.body}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  marginTop: "auto",
                }}
              >
                {p.bullets.map((b) => (
                  <div
                    key={b}
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <CheckMark size={14} />
                    <span
                      style={{ fontSize: 13, color: "var(--cy-ink-80)" }}
                    >
                      {b}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
